import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import styles from "../../../../DatiSpecifici/DatiSpecifici.module.css";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import Utils from "../../../../../../../utils/Utils";

class DatiSegnalazioneTubercolosi extends Component {

    state = {
        datiSegnalazione: {
            malattia: "",
            regione: "",
            provincia: "",
            corretto: []
        },
        regioni: OggettiUtili.Regioni,
        province: JSON.parse(sessionStorage.getItem("province")),
        provincePerCodice: JSON.parse(sessionStorage.getItem("provincePerCodice"))
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.createOggettoBE = this.createOggettoBE.bind(this)
    }

    componentDidMount() {
        let datiSegnalazione = this.state.datiSegnalazione

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiSegnalazione) {
            let datiSegnalazioneProps = this.props.segnalazioneCopia.schedaSpeciale.datiSegnalazione

            datiSegnalazione.malattia = datiSegnalazioneProps.malattia ? datiSegnalazioneProps.malattia : this.state.datiSegnalazione.malattia
            if (datiSegnalazioneProps.regione && datiSegnalazioneProps.regione.length===2){
                datiSegnalazioneProps.regione=datiSegnalazioneProps.regione.concat("0")
            }
            if (this.state.datiSegnalazione.regione && this.state.datiSegnalazione.regione.length===2){
                this.state.datiSegnalazione.regione=this.state.datiSegnalazione.regione.concat("0")
            }
            datiSegnalazione.regione = datiSegnalazioneProps.regione ? this.state.regioni[datiSegnalazioneProps.regione] : this.state.datiSegnalazione.regione
            datiSegnalazione.provincia = datiSegnalazioneProps.provincia ? this.state.provincePerCodice[datiSegnalazioneProps.provincia] : this.state.datiSegnalazione.provincia
            if (this.props.malattia === Utils.mapMalattieDescrizione("TUBERCOLOSI")) {
                datiSegnalazione.malattia = "1"
            }
            this.setState({datiSegnalazione: datiSegnalazione});
            let oggetto = this.createOggettoBE()
            this.props.setDatiSegnalazioneTubercolosi(this.state.datiSegnalazione, oggetto)
        } else {
            if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.malattia === Utils.mapMalattieDescrizione("TUBERCOLOSI")) {
                datiSegnalazione.malattia = "1"
            }
            datiSegnalazione.regione = OggettiUtili.Regioni["050"]
            this.setState({datiSegnalazione: datiSegnalazione});
            let oggetto = this.createOggettoBE()
            this.props.setDatiSegnalazioneTubercolosi(this.state.datiSegnalazione, oggetto)
        }
    }


    riceviValore(field, event) {
        let datiSegnalazione = this.state.datiSegnalazione
        datiSegnalazione[field] = event.target.value
        this.setState({datiSegnalazione: datiSegnalazione})
        let oggetto = this.createOggettoBE()
        this.props.setDatiSegnalazioneTubercolosi(this.state.datiSegnalazione, oggetto)
    }

    createOggettoBE() {
        let datiSegnalazione = JSON.parse(JSON.stringify(this.state.datiSegnalazione))
        if (datiSegnalazione.regione && datiSegnalazione.regione.codice) {
            datiSegnalazione.regione = datiSegnalazione.regione.codice
        }
        if (datiSegnalazione.provincia && datiSegnalazione.provincia.codice) {
            datiSegnalazione.provincia = datiSegnalazione.provincia.codice
        }

        let datiSegnalazioneBe = Utils.removeEmptyValueFromObject(datiSegnalazione)
        return Utils.removeFieldFromObject(datiSegnalazioneBe, "corretto")
    }

    render() {

        const {t} = this.props

        const datiSegnalazione = (
            <div>
                <h6>{t("SchedaSpecialeTubercolosi.DatiSegnalazione")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-lg-2"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTubercolosi.Malattia")}
                            </p>
                        </div>
                        <div className={"col-lg-8"}>
                            <div className={"row"} style={{opacity: "1"}}>
                                <div className={"col-lg-3"}>
                                    <RadioButton className={styles.testo} id={"tubercolosi"}
                                                 name={"malattia"} label={t("SchedaSpecialeTubercolosi.Tubercolosi")}
                                                 value={"1"}
                                                 style={{color: "black", fontWeight: "bold"}}
                                                 checked={this.state.datiSegnalazione.malattia === "1"}
                                                 onClick={this.riceviValore}
                                                 newRadio={true}
                                                 disabled={true}
                                    >
                                    </RadioButton>
                                </div>
                                <div className={"col-lg-3"}>
                                    <RadioButton id={"micobatteriosi"} name={"malattia"}
                                                 label={t("SchedaSpecialeTubercolosi.Micobatteriosi")}
                                                 value={"2"}
                                                 style={{color: "black", fontWeight: "bold"}}
                                                 checked={this.state.datiSegnalazione.malattia === "2"}
                                                 onClick={this.riceviValore}
                                                 newRadio={true}
                                                 disabled={true}
                                    >
                                    </RadioButton>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-lg-2"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTubercolosi.Regione")}</p>
                        </div>
                        <div className={"col-lg-6"}>
                            <Autocomplete
                                id={"idRegione"}
                                onChange={this.riceviValore}
                                field={"regione"}
                                keyField={"codice"}
                                descriptionField={"descrizione"}
                                suggestionField={"descrizione"}
                                value={this.state.datiSegnalazione.regione}
                                suggestions={this.state.regioni}
                                disabled={true}
                                placeholder={t("SchedaSpecialeTubercolosi.Regione")}
                            >
                            </Autocomplete>
                        </div>

                    </div>
                    <div className={"row"} style={{marginTop: "1rem"}}>
                        <div className={"col-lg-2"}>
                            <p className={styles.testo} style={{color: "black", fontWeight: "bold"}}>
                                {t("SchedaSpecialeTubercolosi.Provincia")}
                            </p>
                        </div>
                        <div className={"col-lg-6"}>
                            <div style={{height: "5px"}}>
                                <Autocomplete id={"idProvincia"}
                                              value={this.state.datiSegnalazione.provincia}
                                              keyField={"codice"}
                                              descriptionField={"descrizione"}
                                              suggestionField={"descrizione"}
                                              onChange={this.riceviValore}
                                              field={"provincia"}
                                              placeholder={t("SchedaSpecialeTubercolosi.Provincia")}
                                              suggestions={this.state.datiSegnalazione && this.state.datiSegnalazione.regione && this.state.datiSegnalazione.regione.codice ?
                                                  Utils.filtroProvinceComuni(this.state.datiSegnalazione && this.state.datiSegnalazione.regione && this.state.datiSegnalazione.regione.codice, this.state.province, "codiceRegione") : ""}
                                              disabled={!this.state.datiSegnalazione && this.state.datiSegnalazione.regione && this.state.datiSegnalazione.regione.codice}
                                >
                                </Autocomplete>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

        return (
            <div>
                {datiSegnalazione}
            </div>
        );
    }
}

export default withTranslation('common')(DatiSegnalazioneTubercolosi)
